import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed w-full z-50 bg-[#1a1c1b]/90 backdrop-blur-md border-b border-[var(--border-light)]">
      <div className="container-custom mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="text-2xl font-bold font-display uppercase tracking-tighter text-[var(--brand-primary)]">
            Soo Hoo Consulting
          </Link>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8 items-center">
            <Link to="/#services" className="text-sm font-medium uppercase tracking-wider hover:text-[var(--brand-primary)] transition-colors">Services</Link>
            <Link to="/#about" className="text-sm font-medium uppercase tracking-wider hover:text-[var(--brand-primary)] transition-colors">About</Link>
            <Link to="/contact" className="btn-primary text-sm px-6 py-2">Contact</Link>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-white" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden absolute top-full left-0 w-full bg-[#1a1c1b] border-b border-[var(--border-light)] p-6 flex flex-col space-y-4">
            <Link to="/#services" className="text-lg font-medium uppercase" onClick={() => setIsOpen(false)}>Services</Link>
            <Link to="/#about" className="text-lg font-medium uppercase" onClick={() => setIsOpen(false)}>About</Link>
            <Link to="/contact" className="btn-primary text-center" onClick={() => setIsOpen(false)}>Contact</Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
